export const closedReasonFilterTypes = {
  ALL_CLOSED_REASONS: "ALL",
  NOT_IN_STOCK: "NOT_IN_STOCK",
  INCORRECT: "INCORRECT",
  ALREADY_RESOLVED: "ALREADY_RESOLVED",
  OTHER: "OTHER",
};
